import { render, staticRenderFns } from "./timer.component.vue?vue&type=template&id=ec85c78a&scoped=true"
import script from "./timer.component.vue?vue&type=script&lang=js"
export * from "./timer.component.vue?vue&type=script&lang=js"
import style0 from "./timer.component.vue?vue&type=style&index=0&id=ec85c78a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec85c78a",
  null
  
)

export default component.exports